import { DetallCarrer } from './../../pages/detallCarrer/detallCarrer';
import { NavController } from 'ionic-angular';
import { Component, Input } from '@angular/core';

import { ModalShare } from './../../components/modal-share/modal-share';
import { State } from './../../providers/state';
@Component({
  selector: 'carrer-llista',
  templateUrl: 'carrer-llista.html'
})
export class CarrerLlistaComponent{

  text: string;
  public star : boolean;
  public estrella: string;
  @Input () id: number;
  @Input () adreca: string;
  @Input () tipo: string;
  @Input () regim: string;
  @Input () urlimg: string;
  @Input () espai: string;
  @Input () location: any;

  constructor(public state: State, public navCtrl: NavController) {

  }

  ngOnInit(){
    this.star = !this.state.comprovaImmobleExistent(this.id);
    this.estrella = (this.star)?"active":"nactive";
  }

  changeBoolean (){
    if(this.star){
      this.state.deleteImmoble(this.id);
    }else{
      this.state.setImmoble(this.id);
    }
    this.star = !this.star;
    this.estrella = (this.star)?"active":"nactive";
  }

  goToDetallCarrer(){
    this.navCtrl.push(DetallCarrer, {
      'OBJECTID': this.id
    });
  }

  openShare(){
    this.navCtrl.push(
      ModalShare, 
      {'OBJECTID': this.id,
      'nomNau': this.adreca
    });
  }

  setSlideWidth(location){
    if((location.Tl_1contac != " " && location.Tl_2contac != " ") && location.E_mail != " "){
      return "petit";
    }else if((location.Tl_1contac != " " && location.Tl_2contac != " ") || location.E_mail != " "){
      return "semi";
    }else{
      return "gros";
    }
  }


}



// WEBPACK FOOTER //
// ./src/components/carrer-llista/carrer-llista.ts